import { forwardRef, useCallback } from 'react';
import { LOCAL_WIDGET_ID } from '@elfsight/lib-utils';
import type { SubmitActionType } from '@elfsight/widget-form-builder/configurator';
import {
  Form,
  FormProvider,
  WidgetProvider
} from '@elfsight/widget-form-builder/widget';
import { WidgetI18nProvider } from '@elfsight/widget-i18n';
import { useBanner } from '../../bannerProvider';
import type { FormLayoutProps } from './FormLayout';
import { FormLayout } from './FormLayout';

export type FormBlockProps = FormLayoutProps;

export const FormBlock = forwardRef<HTMLDivElement, FormBlockProps>(
  ({ onSubmitSuccessful, ...formProps }, forwardingRef) => {
    const { trackGoogleAnalyticsEvents, widgetId } = useBanner();

    const handleFormSubmit = useCallback(
      (submitAction: SubmitActionType) => {
        onSubmitSuccessful?.(submitAction);

        trackGoogleAnalyticsEvents?.({ eventType: 'formSubmitted' });
      },
      [trackGoogleAnalyticsEvents, onSubmitSuccessful]
    );

    return (
      <WidgetI18nProvider dictionary={{}} language="en" override={{}}>
        <WidgetProvider>
          <FormProvider widgetId={widgetId || LOCAL_WIDGET_ID}>
            <Form {...formProps} onSubmitSuccessful={handleFormSubmit}>
              <FormLayout {...formProps} ref={forwardingRef} />
            </Form>
          </FormProvider>
        </WidgetProvider>
      </WidgetI18nProvider>
    );
  }
);
